import { render } from "./TheNavbarNews.pug?vue&type=template&id=0f95abcc&lang=pug"
import script from "./TheNavbarNews.js?vue&type=script&lang=js"
export * from "./TheNavbarNews.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__